<template>
  <div>
    <el-upload
      drag
      action="#"
      :http-request="customUpload"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :show-file-list="false"
    >
      <div class="image-operate-btn" v-if="loginBg">
        <el-tooltip :content="$t('text.crop_image')" placement="top">
          <i
            class="el-icon-edit btn-item"
            @click.stop="openCropImageDialog"
          ></i>
        </el-tooltip>
        <el-tooltip :content="$t('text.remove_image')" placement="top">
          <i class="el-icon-close btn-item" @click.stop="handleRemove"></i>
        </el-tooltip>
      </div>
      <img v-if="loginBg" :src="loginBg" class="max-wp-100 max-hp-100" />
      <div v-else v-loading="loading">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $t('text.drag_the_login_background_here') }}, {{ $t('text.or')
          }}<em> {{ $t('text.click_upload') }}</em>
        </div>
      </div>
      <div class="el-upload__tip" slot="tip">
        <div>1. {{ $t('text.only_image_files_can_be_uploaded') }}</div>
        <div>
          2. {{ $t('text.the_size_of_the_uploaded_image_cannot_exceed') }}
        </div>
        <b>3. {{ $t('text.please_sign_out_to_preveiw_effect') }}</b>
      </div>
    </el-upload>
    <CropImage ref="cropImage" :image="loginBg" @completeCrop="completeCrop" />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import CropImage from '@/components/manage/admin/customization/CropImage'
export default {
  data() {
    return {
      loginBg: '',
      loading: false
    }
  },
  components: {
    CropImage
  },
  mounted() {
    if (this.$store.state.customization.loginBg) {
      this.loginBg = this.$store.state.customization.loginBg
    }
  },
  methods: {
    customUpload(params) {
      const file = params.file
      this.loading = true
      let obj = new FormData()
      obj.append('file', file)
      ApiService.UploadIMGFile('background', obj)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.loginBg = response.data.data
            this.$store.commit('customization/SET_LOGIN_BG', this.loginBg)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    beforeUpload(file) {
      const allowType = ['image/jpeg', 'image/png']
      const isImg = allowType.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error(this.$t('text.only_image_files_can_be_uploaded'))
      }
      if (!isLt2M) {
        this.$message.error(
          this.$t('text.the_size_of_the_uploaded_image_cannot_exceed')
        )
      }

      return isImg && isLt2M
    },
    handleRemove() {
      this.loginBg = ''
    },
    openCropImageDialog() {
      this.$refs.cropImage.openDialog()
    },
    completeCrop(image) {
      this.loginBg = ''
      this.customUpload({
        file: image
      })
    }
  }
}
</script>
